// extracted by mini-css-extract-plugin
export default {"footer":"MobileFooter_footer__Dc38p"};